import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchDemandbaseCompanyData = createAction(constants.FETCH_DEMANDBASE_COMPANY_DATA)
export const fetchDemandbaseCompanyDataPending = createAction(constants.FETCH_DEMANDBASE_COMPANY_DATA_PENDING)
export const fetchDemandbaseCompanyDataSuccess = createAction(constants.FETCH_DEMANDBASE_COMPANY_DATA_SUCCESS)
export const fetchDemandbaseCompanyDataFailed = createAction(constants.FETCH_DEMANDBASE_COMPANY_DATA_FAILED)
export const fetchDemandbaseCompanyDataCancelled = createAction(constants.FETCH_DEMANDBASE_COMPANY_DATA_CANCELLED)

export const fetchDemandbaseTargetingIndustries = createAction(constants.FETCH_DEMANDBASE_TARGETING_INDUSTRIES)
export const fetchDemandbaseTargetingIndustriesPending = createAction(constants.FETCH_DEMANDBASE_TARGETING_INDUSTRIES_PENDING)
export const fetchDemandbaseTargetingIndustriesSuccess = createAction(constants.FETCH_DEMANDBASE_TARGETING_INDUSTRIES_SUCCESS)
export const fetchDemandbaseTargetingIndustriesFailed = createAction(constants.FETCH_DEMANDBASE_TARGETING_INDUSTRIES_FAILED)

export const fetchDemandbaseTargetingSubIndustries = createAction(constants.FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES)
export const fetchDemandbaseTargetingSubIndustriesPending = createAction(constants.FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_PENDING)
export const fetchDemandbaseTargetingSubIndustriesSuccess = createAction(constants.FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_SUCCESS)
export const fetchDemandbaseTargetingSubIndustriesFailed = createAction(constants.FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_FAILED)





// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/demandbase/actions.js